import i18n from "@/plugins/vue-i18n";

import Categories from "@/views/settings/categories/index";
import CategoriesAdd from "@/views/settings/categories/add";
import CategoriesEdit from "@/views/settings/categories/edit";

const categories = [
  {
    path: "settings/categories",
    name: "Categories",
    component: Categories,
    meta: {
      title: i18n.t("title.categories._"),
    },
  },
  {
    path: "settings/categories/add",
    name: "CategoriesAdd",
    component: CategoriesAdd,
    meta: {
      title: i18n.t("title.categories.add"),
    },
  },
  {
    path: "settings/categories/:id/edit",
    name: "CategoriesEdit",
    component: CategoriesEdit,
    meta: {
      title: i18n.t("title.categories.edit"),
    },
  },
];

export default categories;
